import NAV from "../Nav/nav"
import "../Header/header.css"

function Header (){
    return(
            <NAV />
    )
}
export default Header